import $ from 'jquery';  // Import jQuery
// import menuTemplate from '../../templates/menu.hbs';
import headerTemplate from '../../templates/header.hbs';
import mainNavigationTemplate from '../../templates/main-navigation.hbs';
import loginModalTemplate from '../../templates/login.hbs';
import loggedInModalTemplate from '../../templates/loggedin.hbs';
import registerModalTemplate from '../../templates/register.hbs';
import registeredModalTemplate from '../../templates/registered.hbs';
import forgotModalTemplate from '../../templates/forgot-password.hbs';
import helpModalTemplate from '../../templates/help-modal.hbs';
import {clearCookies, getCookie, setCookie} from "./api";
import {bindModalClose, bindModalOpen, openModal, closeModal} from "./modals";
import {setupForgotPassword, setupLogin} from "./login";
import {setupRegister} from "./register";
import {showRegisterModal} from "../register";
import {showLoggedInModal, showLoginModal} from "../login";
import {updateHeaderName} from "./users";

// console.log("main.js is loaded and running.");

let bitmapData = [];
window.bitmapData = bitmapData;

// CONFIG
var navigation_slide_in_time = 250,
    gallery_display_filters = [],
    help_window_bitmation_duration = 350,
    scroll_to_top_bitmation_time = 350,
    is_mobile = false,
    mobile_threshhold = 600;

// Check if the user is authenticated
var accessToken = getCookie('access_token');
var isAuthenticated = !!accessToken;  // Boolean flag for Handlebars


function slideMainMenu(menu, overlay, action) {
    var navigation = $('#main-navigation'),
        amount = 0;
    if (action !== 'open') {
        amount = -340;
        overlay.stop().fadeOut(navigation_slide_in_time);
    } else {
        navigation.show();
        overlay.stop().fadeIn(navigation_slide_in_time);
    }
    menu.stop().animate({
        right: amount
    }, navigation_slide_in_time, function () {
        if (action !== 'open') {
            navigation.hide();
            $(this).removeAttr('style');
        }
    });
}

// Attach to window object
window.slideMainMenu = slideMainMenu;

$(document).ready(function () {
    // Cookie banner is initialized after it's loaded

    $('#main-navigation').load('../../common/main-navigation.html', function () {
        // console.log("main-navigation loaded.");
        // Render the login/logout menu item using Handlebars
        var mainNavigationHtml = mainNavigationTemplate({isAuthenticated: isAuthenticated});
        $('#main-navigation').html(mainNavigationHtml);

        // If the user is authenticated, attach logout functionality
        if (isAuthenticated) {
            // otherwise login functionality
            $('#logged-in-modal').load('../../common/loggedin.html', function () {
                $('#logged-in-modal').html(loggedInModalTemplate);

                try {
                    if (loginModalShow) {
                        showLoggedInModal();
                    }
                } catch (e) {

                }

            });
            $('#register-modal').load('../../common/register.html', function () {
                $('#register-modal').html(registeredModalTemplate);

                try {
                    if (registerModalShow) {
                        showRegisterModal();
                    }
                } catch (e) {

                }
            });
            $('#logout-link').on('click', function (event) {
                event.preventDefault();
                // Clear the access and refresh tokens
                clearCookies();
                window.location.href = "/";
            });
        } else {
            // otherwise login functionality
            $('#log-in-modal').load('../../common/login.html', function () {
                $('#log-in-modal').html(loginModalTemplate);

                setupLogin();
                try {
                    if (loginModalShow) {
                        showLoginModal();
                    }
                } catch (e) {

                }

            });
            $('#register-modal').load('../../common/register.html', function () {
                $('#register-modal').html(registerModalTemplate);

                setupRegister();
                try {
                    if (registerModalShow) {
                        showRegisterModal();
                    }
                } catch (e) {

                }
            });
            $('#forgot-password-modal').load('../../common/forgot-password.html', function () {
                $('#forgot-password-modal').html(forgotModalTemplate);

                setupForgotPassword();
            });

        }
        document.body.style.visibility = 'visible';

        // });

        // Load the header and footer
        $('#header').load('../../common/header.html', function () {
            // console.log("Header loaded.");

            let nickname = getCookie('nickname');

            var headerHtml = headerTemplate({isAuthenticated: isAuthenticated, nickname: nickname});
            $('#header').html(headerHtml);

            if (isAuthenticated) {
                updateHeaderName();
            }

            const interfaceContainer = document.querySelector('#user-prompt');
            let navigation = $('#main-navigation');

            // Ensure it's hidden initially
            interfaceContainer.classList.add('hidden');

            // Simulate JavaScript setup (e.g., adding event handlers)
            $('#menu-trigger').on('click', function (e) {
                // console.log("Menu trigger clicked.");
                e.preventDefault();
                slideMainMenu(navigation.find('.main-menu'), navigation.find('.overlay'), 'open');
            });

            $('.close-menu, #main-navigation .overlay').on('click', function (e) {
                e.preventDefault();
                slideMainMenu(navigation.find('.main-menu'), navigation.find('.overlay'), 'close');
            });

            // Add help modal to the page
            $('body').append(helpModalTemplate);

            bindModalOpen();
            bindModalClose();

            // Bind info icon click to open help modal
            $('.info-icon').on('click', function(e) {
                e.preventDefault();
                var navigation = $('#main-navigation');
                slideMainMenu(navigation.find('.main-menu'), navigation.find('.overlay'), 'close');
                $('.modal').hide();
                openModal('help-modal');
            });

            // Once setup is complete, show the interface
            interfaceContainer.classList.remove('hidden');
            slideMainMenu(navigation.find('.main-menu'), navigation.find('.overlay'), 'close');
            document.body.style.visibility = 'visible';
            checkEnvironment();
        });
    });
    $('#footer').load('../../common/footer.html', function () {
        // console.log("Footer loaded.");
    });

    // Load cookie banner
    $('body').append($('<div>').load('../../common/cookie-banner.html', function() {
        // console.log("Cookie banner loaded");
        // console.log("All cookies:", document.cookie);

        // Initialize cookie banner after it's loaded
        initCookieBanner();

        // Add jQuery click handler as backup
        $('#accept-cookies').on('click', function(e) {
            // console.log('jQuery click handler triggered');
            e.preventDefault();

            // Set cookie with multiple approaches to ensure it works
            setCookie('cookie_consent', 'accepted', 365);

            // Also set with direct document.cookie approach
            const date = new Date();
            date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
            document.cookie = `cookie_consent=accepted; expires=${date.toUTCString()}; path=/; SameSite=Lax`;

            // console.log("Cookie after setting:", document.cookie);
            $('#cookie-banner').css('bottom', '-260px');
        });
    }));
});


// Function to check the SITE_ENV environment variable and hide the 'Local' banner if SITE_ENV is 'production'
function checkEnvironment() {
    const siteEnv = process.env.SITE_ENV;
    const versionBanner = document.getElementById('version_banner');
    
    // Only show banner for non-production environments
    if (versionBanner && siteEnv && siteEnv !== 'production') {
        $('#version_banner').html(siteEnv);
        versionBanner.style.display = 'block';
    }
    // Banner remains hidden by default (CSS) for production
}

// Function to handle cookie consent banner
function initCookieBanner() {
    // console.log("Initializing cookie banner");
    const cookieBanner = document.getElementById('cookie-banner');
    const acceptCookieBtn = document.getElementById('accept-cookies');

    // console.log("Cookie banner element:", cookieBanner);
    // console.log("Accept button element:", acceptCookieBtn);

    // Check if user has already accepted cookies through multiple approaches
    const hasConsent = getCookie('cookie_consent') === 'accepted';
    // console.log("Existing cookie consent:", hasConsent);
    // console.log("All cookies:", document.cookie);

    // Also check directly in the cookie string for maximum compatibility
    const directCheck = document.cookie.indexOf('cookie_consent=accepted') !== -1;
    // console.log("Direct cookie check:", directCheck);

    if (hasConsent || directCheck) {
        // console.log("User has already accepted cookies, keeping banner hidden");
        if (cookieBanner) {
            cookieBanner.style.bottom = '-260px'; // Force it to stay hidden
        }
    } else {
        if (cookieBanner) {
            // console.log("User has not accepted cookies, showing banner");
            // Slight delay before showing the banner for better UX
            setTimeout(() => {
                cookieBanner.style.bottom = '0';
                // console.log("Showing cookie banner");
            }, 1000);
        }
    }

    // Add event listener to accept button
    if (acceptCookieBtn) {
        // console.log("Adding click event listener to accept button");

        acceptCookieBtn.addEventListener('click', function(e) {
            // console.log("Got it button clicked");
            e.preventDefault();

            // Set cookie to remember user's consent
            setCookie('cookie_consent', 'accepted', 365); // Cookie valid for 1 year
            // console.log("Cookie set:", getCookie('cookie_consent'));

            // Hide banner with transition
            if (cookieBanner) {
                cookieBanner.style.bottom = '-260px';
                // console.log("Hiding cookie banner");
            }
        });
    } else {
        // console.warn("Accept button not found!");
    }
}

// Call the functions on page load
// document.addEventListener('DOMContentLoaded', checkEnvironment);
